window.AB_TESTS = {
  DISCOUNT_TEST_PDP_CART_V2: {
    testId: "64059527",
    controlVariantId: "29996155",
    testVariantId: "37544549",
  },
  HOMEPAGE_CTA_TEXT: {
    testId: "45918896",
    controlVariantId: "26729206",
    testVariantId: "87981158",
  },
  CUSTOM_GORGIAS_CHAT_PART_1: {
    testId: "23371763",
    controlVariantId: "47780498",
    testVariantId: "73045583",
  },
};

window.isUserInABTestGroup = function (testName) {
  try {
    const ablyftTools = window.ablyft?.getTools();
    if (!ablyftTools) {
      console.warn("ablyft tools not found");
      return false;
    }
    const test = window.AB_TESTS[testName];
    if (!test) {
      console.warn("test not found");
      return false;
    }
    const ablyftAbTests = JSON.parse(ablyftTools.getSetBucketingUrlExtension());
    if (!ablyftAbTests) {
      console.warn("ablyft ab tests not found");
      return false;
    }
    const activeAbTests = ablyftAbTests.map((abTest) => ({
      testId: abTest.split("_")[0],
      variantId: abTest.split("_")[1],
    }));
    return activeAbTests.some(
      (abTest) =>
        abTest.testId === test.testId &&
        abTest.variantId === test.testVariantId,
    );
  } catch (error) {
    console.error("Error checking if user is in AB test group", error);
    return false;
  }
};
